export default "__VITE_ASSET__BK$g$z9T__"